function e(e,t,n){return typeof t==`number`||t===void 0?n=>n.split(e,t):e.split(t,n)}export{e as split};
//# sourceMappingURL=split-BdjP49wL.js.map